import {Component, ChangeDetectionStrategy} from '@angular/core';
import {AuthService} from '../auth/auth.service';
import {ErrorSharedComponent} from './error-shared.component';

@Component({
    selector: 'error404',
    templateUrl: './error404.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class Error404Component extends ErrorSharedComponent {

  constructor(protected authService: AuthService) {
    super();
  }
}
